// Icons of the Bulk Photo Edit tools (backend config/bulkPhotoThemes.js ids) — shared by the bulk editor's option cards and
// the Studio Editor's extra-instruction grid, so a tool reads the same in both.
import {
    IconSparkles, IconEye,
    IconWand, IconEraser, IconMoon, IconMoodSmile, IconRipple, IconBrush, IconScissors,
    IconAdjustments, IconPalette, IconDroplet, IconFlame, IconSnowflake, IconMovie, IconHistory,
    IconBulb, IconLamp, IconSun, IconContrast, IconSunset2,
    IconShirt, IconWind, IconHanger, IconGrain,
    IconBlur, IconLayoutGrid, IconClearAll, IconTree, IconHeart,
    IconRestore, IconBandage, IconFocusCentered, IconArrowsMaximize,
    IconAward, IconUserCircle, IconId,
} from '@tabler/icons-react';

// Icon per tool id → shown on the option cards so tools read at a glance.
const TOOL_ICONS = {
    // Face Enhance
    'skin-smoothing': IconWand, 'blemish-removal': IconEraser, 'dark-circle-fix': IconMoon,
    'teeth-whitening': IconMoodSmile, 'eye-brighten': IconEye, 'wrinkle-softening': IconRipple,
    'light-makeup': IconBrush, 'hair-tidy': IconScissors,
    // Color
    'color-correction': IconAdjustments, 'bw-to-color': IconPalette, 'vivid-colors': IconDroplet,
    'warm-tone': IconFlame, 'cool-tone': IconSnowflake, 'cinematic-grade': IconMovie, 'vintage-retro': IconHistory,
    // Light
    'light-correction': IconBulb, 'studio-lighting': IconLamp, 'brighten-photo': IconSun,
    'shadow-highlight-fix': IconContrast, 'golden-hour': IconSunset2,
    // Dress
    'dress-color-change': IconShirt, 'cloth-wrinkle-removal': IconWind, 'saree-enhance': IconHanger, 'fabric-texture': IconGrain,
    // Background
    'bg-blur': IconBlur, 'studio-background': IconLayoutGrid, 'remove-distractions': IconClearAll,
    'outdoor-bg': IconTree, 'wedding-bg': IconHeart,
    // Restore
    'restore-old-photo': IconRestore, 'scratch-repair': IconBandage, 'deblur-sharpen': IconFocusCentered, 'hd-upscale': IconArrowsMaximize,
    // Studio Quality
    'studio-quality': IconAward, 'professional-portrait': IconUserCircle, 'passport-ready': IconId,
};
// Representative icon per main category.
const CATEGORY_ICONS = {
    face: IconMoodSmile, color: IconPalette, light: IconBulb, dress: IconShirt,
    background: IconLayoutGrid, restore: IconRestore, studio: IconAward,
};
export const toolIcon = (id) => TOOL_ICONS[id] || IconSparkles;
export const categoryIcon = (id) => CATEGORY_ICONS[id] || IconSparkles;
